import {
  BarChart3,
  Clock,
  Ticket,
  Users,
  type LucideIcon,
} from "lucide-react";

export interface CoreFeature {
  title: string;
  description: string;
  icon: LucideIcon;
  iconColorClass: string;
  iconBgClass: string;
  cardBgClass: string;
}

export const CORE_FEATURES: ReadonlyArray<CoreFeature> = [
  {
    title: "Ticket Management",
    description:
      "Organize support requests, assign tasks, and track resolutions. Keep your team aligned and your clients happy with a streamlined helpdesk.",
    icon: Ticket,
    iconColorClass: "text-blue-600",
    iconBgClass: "bg-blue-100",
    cardBgClass: "bg-blue-50/50",
  },
  {
    title: "Time Tracking",
    description:
      "Effortlessly capture billable hours. Integrated timers and logs ensure you never lose revenue due to unrecorded work.",
    icon: Clock,
    iconColorClass: "text-green-600",
    iconBgClass: "bg-green-100",
    cardBgClass: "bg-green-50/50",
  },
  {
    title: "Client Management",
    description:
      "Maintain detailed records of your clients, contracts, and contacts. Access critical information instantly when you need it.",
    icon: Users,
    iconColorClass: "text-purple-600",
    iconBgClass: "bg-purple-100",
    cardBgClass: "bg-purple-50/50",
  },
  {
    title: "Reporting & Analytics",
    description:
      "Gain insights into your business performance. Visual dashboards help you spot trends, optimize resources, and prove value to clients.",
    icon: BarChart3,
    iconColorClass: "text-orange-600",
    iconBgClass: "bg-orange-100",
    cardBgClass: "bg-orange-50/50",
  },
];

export const BENEFITS: ReadonlyArray<string> = [
  "Unified interface reduces context switching",
  "Designed specifically for MSP workflows",
  "Secure role-based access control",
  "Client portal for transparent communication",
  "Scalable architecture that grows with you",
  "Automated billing and invoicing integration",
];

export interface StatTile {
  value: string;
  label: string;
  bgClass: string;
  valueColorClass: string;
}

export const STAT_TILES: ReadonlyArray<StatTile> = [
  {
    value: "30%",
    label: "Efficiency Boost",
    bgClass: "bg-blue-50",
    valueColorClass: "text-blue-600",
  },
  {
    value: "100%",
    label: "Time Captured",
    bgClass: "bg-green-50",
    valueColorClass: "text-green-600",
  },
  {
    value: "24/7",
    label: "System Uptime",
    bgClass: "bg-purple-50",
    valueColorClass: "text-purple-600",
  },
  {
    value: "50+",
    label: "Happy MSPs",
    bgClass: "bg-orange-50",
    valueColorClass: "text-orange-600",
  },
];
